import { store } from '../store';

export const getStateAdfsProvider = () => store.getState().auth.adfsProvider;
store.subscribe(getStateAdfsProvider);



// WEBPACK FOOTER //
// ./src/selectors/index.js